








































































































import Moment from "moment";
import Enumerable from "linq";
import { Component, Mixins, Prop, } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { DateDuration } from "../../../../domain/system";
import { HisInformation, HisInformationListItem } from "../../../../domain/his";
import { HisItemParameter, InformationKinds, } from "../../../../domain/his/behavior";
import { Patient } from "../../../../domain/patient";
import { Profession } from "../../../../domain/user";
import { IAiPhraseVariable, IAiPhraseRecord, IAiPhraseVariableValid, } from "../../../../domain/externalSystem";
import { DialogMixin } from "../../../system/mixins";
import { TemporarySaveUserFixedPhraseSelector } from "../../fixedPhrase";
import { FixedLoading } from "../../../system";
import { PresettableDateDurationPicker, ComboBoxSelector } from "../../../system/selectors";
import HisInfoListSelectDialog from "../../../his/dialogs/HisInfoListSelectDialog.vue";
import { MultiOrderableProfessionListSelectorDialog } from "../../../profession/dialogs";
import { AiPhraseEditor } from "./contents";
import AiTranslationDialog from "./AiTranslationDialog.vue";
import AiMedicalRecordsViewDialog from "./AiMedicalRecordsViewDialog.vue";
import { Department } from "../../../../domain/department";
import { MultiDepartmentListSelectorDialog } from "../../../../components/department";

type Action = "insertToCaretPosition" | "insertToFirst" | "insertToLast" | "overwrite" | "locate" | "apply";
interface EnableActions {
  insertToCaretPosition?: boolean;
  insertToFirst?: boolean;
  insertToLast?: boolean;
  overwrite?: boolean;
  locate?: boolean;
  apply?: boolean;
}
interface Options {
  template: string;
  duration?: {
    from?: Date;
    to?: Date;
  };
  recipe?: string;
  actions: EnableActions;
  title?: string;
}
interface ResultBase<T extends boolean> {
  isConfirmed: T;
}
interface ResultConfimed extends ResultBase<true> {
  phrase: string;
  variables: { [key: string]: IAiPhraseVariable };
  action: Action;
}
interface ResultCancelled extends ResultBase<false> {}
type Result = ResultConfimed | ResultCancelled;
interface CreationConditions {
  duration: DateDuration;
  professionIds: string[];
  departmentIds: string[];
}
interface PreprocessOption {
  departmentCodes?: string[];
  authorRoleCodes?: string[];
}

@Component({
  components: {
    PresettableDateDurationPicker,
    TemporarySaveUserFixedPhraseSelector,
    FixedLoading,
    HisInfoListSelectDialog,
    AiPhraseEditor,
    ComboBoxSelector,
    AiTranslationDialog,
    AiMedicalRecordsViewDialog,
    MultiOrderableProfessionListSelectorDialog,
    MultiDepartmentListSelectorDialog,
  }
})
export default class AiPhraseDialog extends Mixins(DialogMixin) {
  options: Options = {
    template: "",
    actions: {},
  };
  duration = new DateDuration(null, null);
  phrase = "";
  createdTemplate = "";
  variables: { [key: string]: IAiPhraseVariable } = null;
  action: Action | undefined = undefined;
  isPhraseCreating = false;
  isPhraseCreated = false;
  isCreatedPhraseValid = false;
  editinglanguageToTranslate = "";
  translatedPhrase = "";
  isFilterLoading = false;
  departmentEntities = [] as Department[];
  professionEntities = [] as Profession[];

  @Prop()
  patient: Patient;

  @Prop()
  hisInformation: HisInformation;

  $refs!: {
    hisInfoListDialog: HisInfoListSelectDialog,
    aiTranslationDialog: AiTranslationDialog,
    aiMedicalRecordsViewDialog: AiMedicalRecordsViewDialog,
    professionListSelectorDialog: MultiOrderableProfessionListSelectorDialog,
    departmentListSelectorDialog: MultiDepartmentListSelectorDialog,
  };

  data(): any {
    return {
      hisItemParameter: null as HisItemParameter,
      languageToTranslate: "",
      records: [],
      validCreationConditions: null as CreationConditions,
      professions: [],
      departments: [],
    };
  }
  hisItemParameter: HisItemParameter;
  languageToTranslate: string;
  records: IAiPhraseRecord[];
  validCreationConditions: CreationConditions;
  professions: Profession[];
  departments: Department[];

  created(): void {
    this.createHisItemParameter();
  }

  async mounted(): Promise<void> {
    this.languageToTranslate = this.languageOptions.length > 0 ? this.languageOptions[0] : "";
    await this.setFilterMaster();
  }

  get title(): string {
    return this.options && this.options.title
      ? this.options.title
      : "文章生成";
  }

  get complementedDuration(): DateDuration {
    return new DateDuration(
      this.duration.from,
      this.duration.to ? this.duration.to : new Date());
  }

  get displayTemplate(): string {
    return this.createdTemplate
      ? this.createdTemplate
      : this.options.template;
  }

  get maxDurationDays(): number {
    return this.$configuration.behavior.document.editor.contents.aiPhrase.maxDurationDays;
  }

  get shouldFillNeverHospitalizedDuration(): boolean {
    return this.$configuration.behavior.document.editor.contents.aiPhrase.neverHospitalizedDuration.shouldFill;
  }

  get neverHospitalizedDurationDays(): number {
    return this.$configuration.behavior.document.editor.contents.aiPhrase.neverHospitalizedDuration.days;
  }

  get hospitalizationLastDays(): number {
    return this.$configuration.behavior.document.editor.contents.aiPhrase.hospitalization.finder.lastDays;
  }

  get isProfessionsFilterEnable(): boolean {
    return this.$configuration.behavior.document.editor.contents.aiPhrase.filters.professions.isEnable;
  }

  get isDepartmentFilterEnable(): boolean {
    return this.$configuration.behavior.document.editor.contents.aiPhrase.filters.departments.isEnable;
  }

  get invalidTemplatePhraseDetail(): string {
    if (!this.complementedDuration || !this.complementedDuration.from) {
      return "開始日を指定してください。";
    } else if (this.complementedDuration.from > this.complementedDuration.to) {
      return "開始日は終了日以前を指定してください。";
    } else if (this.maxDurationDays > 0 && this.complementedDuration.days > this.maxDurationDays) {
      return `期間は${this.maxDurationDays}日以内で指定してください。`;
    } else {
      return "";
    }
  }

  get isCreatingTemplatePhraseAvailable(): boolean {
    return !this.invalidTemplatePhraseDetail;
  }

  get isConfirmable(): boolean {
    return this.options.template !== this.phrase && !!this.phrase && this.isCreatedPhraseValid;
  }

  get hasHospitalizationData(): boolean {
    return this.hisInformation && this.hisInformation.hospitalizationCollection.rows.length > 0;
  }

  get isEnableAiTranslation(): boolean {
    return this.$configuration.behavior.document.editor.contents.aiTranslation.isEnable;
  }

  get isTranslatable(): boolean {
    return this.isEnableAiTranslation && this.options.template !== this.phrase && !!this.phrase && this.isCreatedPhraseValid && !!this.languageToTranslate;
  }

  get languageOptions(): string[] {
    return this.$configuration.behavior.document.editor.contents.aiTranslation.languages;
  }

  get languageOptionsWidth(): number {
    return Enumerable.from(this.languageOptions).where(o => !!o).toArray().length > 0
      ? Enumerable.from(this.languageOptions).where(o => !!o).select(o => o.length).max() * 25
      : 100;
  }

  get languageOptionsStyle(): any {
    return {
      width: this.languageOptionsWidth + "px",
      margin: "3px",
    };
  }

  get conditions(): string {
    return "生成条件: " + this.validCreationDurationString;
  }

  get validCreationDurationString(): string {
    return this.validCreationDuration
      ? this.toDurationString(this.validCreationDuration)
      : "";
  }

  get validCreationDuration(): DateDuration {
    return this.validCreationConditions
      ? this.validCreationConditions.duration
      : null;
  }

  get professionIdsCondition(): string[] {
    return this.professions
      ? Enumerable.from(this.professions).select(p => p.id).toArray()
      : null;
  }

  get professionNames(): string {
    return this.professions && this.professions.length > 0
      ? Enumerable.from(this.professions).select(p => p.name).toArray().join(", ")
      : "すべて";
  }

  get departmentIdsCondition(): string[] {
    return this.departments
      ? Enumerable.from(this.departments).select(p => p.id).toArray()
      : null;
  }

  get departmentNames(): string {
    return this.departments && this.departments.length > 0
      ? Enumerable.from(this.departments).select(p => p.name).toArray().join(", ")
      : "すべて";
  }

  createHisItemParameter(): void {
    this.hisItemParameter = new HisItemParameter();
    this.hisItemParameter.informationKind = InformationKinds.Hospitalization;
    this.hisItemParameter.isMultiSelect = false;
  }

  setCurrentAdmissionDuration(): void {
    if (!this.hisInformation || !this.hisInformation.hospitalizationHistories) {
      this.setNeverHospitalizedDuration();
      return;
    }
    const now = new Date();
    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const currentAdmission = Enumerable.from(this.hisInformation.hospitalizationHistories)
      .orderByDescending(h => h.admissionDate)
      .firstOrDefault(d => d.admissionDate <= today);
    if (!currentAdmission) {
      this.setNeverHospitalizedDuration();
      return;
    }

    const lastDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    lastDay.setDate(lastDay.getDate() - this.hospitalizationLastDays);

    const dischargeDate = currentAdmission.dischargeDate ? currentAdmission.dischargeDate : today;
    if (dischargeDate < lastDay) {
      this.setNeverHospitalizedDuration();
      return;
    }

    this.duration = new DateDuration(
      currentAdmission.admissionDate,
      dischargeDate
    );
  }

  setNeverHospitalizedDuration(): void {
    if (!this.shouldFillNeverHospitalizedDuration) { return; }
    const now = new Date();
    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const startDate = new Date(today);
    startDate.setDate(startDate.getDate() - this.neverHospitalizedDurationDays);
    this.duration = new DateDuration(startDate, today);
  }

  async selectFromHospitalizedHistory() {
    const result = await this.$refs.hisInfoListDialog.show();
    // 「×」や「中止する」で閉じたらresult.dataはundefined
    if (result && (result.data || result.data === null)) {
      const source = result.data as HisInformationListItem[];
      // ProofPeriodDialogSelectorに合わせてDATE_TIMEを使用
      this.duration = new DateDuration(
        this.getHisInformationDateTime(source, "ENTER_HOSP_DATE_TIME"),
        this.getHisInformationDateTime(source, "LEAVE_HOSP_DATE_TIME")
      );
    }
  }

  private getHisInformationDateTime(source: HisInformationListItem[], key: string): Date {
    return this.toDate(this.getItemValue(source, key), "YYYYMMDD");
  }

  private toDate(source: string, format: string): Date {
    if (!source) { return null; }
    return Moment(source, format).toDate();
  }

  private getItemValue(items: HisInformationListItem[], name: string): string {
    return Enumerable.from((items && items.length > 0) ? items[0].items : [])
      .where(i => i.name === name)
      .select(i => i.value)
      .firstOrDefault();
  }

  async createPhrase() {
    try {
      this.isPhraseCreating = true;
      const phraseInfo = await DomainRegistry.instance.externalSystem.getAiService().createPhrase(
        this.options.template,
        this.patient.id,
        this.complementedDuration,
        {
          recipe: this.options.recipe,
          professionIds: this.professionIdsCondition,
          departmentIds: this.departmentIdsCondition,
        });
      if (phraseInfo.isError) {
        this.$error("文章生成失敗", phraseInfo.text);
        this.isCreatedPhraseValid = false;
        return;
      }
      this.createdTemplate = phraseInfo.template;
      this.variables = phraseInfo.variables;
      this.records = phraseInfo.records;
      this.isPhraseCreated = true;
      this.isCreatedPhraseValid = true;
      this.validCreationConditions = this.CreateValidCreationConditions();
    } catch (e) {
      this.$error(
        "文章生成失敗",
        "文章生成できませんでした。",
        e
      );
      this.isCreatedPhraseValid = false;
    } finally {
      this.isPhraseCreating = false;
    }
  }

  private CreateValidCreationConditions(): CreationConditions {
    return {
      duration: this.complementedDuration,
      professionIds: this.professionIdsCondition,
      departmentIds: this.departmentIdsCondition,
    };
  }

  async translate() {
    const result = await this.$refs.aiTranslationDialog.show({
      input: this.phrase,
      language: this.languageToTranslate,
      actions: this.options.actions,
    });
    if (!result.isConfirmed) {
      return;
    }
    this.translatedPhrase = result.output;
    this.confirm(result.action);
  }

  async show(options: Options): Promise<Result> {
    return this.showModal(async () => {
      if (!options.template || !options.actions) {
        return {
          isConfirmed: false,
        };
      }
      this.options = options;
      this.phrase = options.template;
      this.action = undefined;
      this.isPhraseCreated = false;
      this.isCreatedPhraseValid = false;
      this.createdTemplate = "";
      this.variables = null;
      this.records = null;
      if (options.duration) {
        this.duration = new DateDuration(options.duration.from, options.duration.to);
      } else {
        this.setCurrentAdmissionDuration();
      }
      this.translatedPhrase = "";
      this.setFilter();
      await this.waitHidden();
      return this.action
      ? {
        isConfirmed: true,
        phrase: !!this.translatedPhrase
          ? this.translatedPhrase
          : this.phrase,
        variables: this.variables,
        action: this.action,
      }
      : {
        isConfirmed: false,
      };
    });
  }

  async showMedicalRecords(): Promise<void> {
    const conditions = "患者番号：" + this.patient.id + " 期間：" + this.toDurationString(this.complementedDuration);
    const evidences = Enumerable.from(this.variables)
      .where(v => (v.value as IAiPhraseVariable).isValid)
      .selectMany(v => (v.value as IAiPhraseVariableValid).evidences)
      .toArray();
    await this.$refs.aiMedicalRecordsViewDialog.show(this.records, conditions, evidences);
  }

  async showProfessionListSelectorDialog(): Promise<void> {
    const result = await this.$refs.professionListSelectorDialog.selectOptions(this.professions);
    if (result === undefined) { return; }
    this.professions = result;
  }

  async showDepartmentListSelectorDialog(): Promise<void> {
    const result = await this.$refs.departmentListSelectorDialog.selectOptions(this.departments);
    if (result === undefined) { return; }
    this.departments = result;
  }

  clearProfessions(): void {
    this.professions = null;
  }


  clearDepartments(): void {
    this.departments = null;
  }

  async setFilter(): Promise<void> {
    try {
      this.isFilterLoading = true;
      const pattern = new RegExp("{[ \r\n\t]*preprocess[ \r\n\t]*\\?[ \r\n\t]*{[^{}]*({[^{}]*})*}[ \r\n\t]*}[ \r\n\t]*");
      const preprocess = this.phrase.match(pattern);
      if (!preprocess || preprocess.length === 0) { return; }

      const option = this.toPreprocessOption(preprocess[0]);
      if (!option) { return; }

      if (this.isDepartmentFilterSettable && option.departmentCodes && option.departmentCodes.length > 0) {
        this.departments = this.departmentEntities.filter(a => option.departmentCodes.some(d => d === a.id));
      }
      if (this.isProfessionFilterSettable && option.authorRoleCodes && option.authorRoleCodes.length > 0) {
        this.professions = this.professionEntities.filter(a => option.authorRoleCodes.some(d => d === a.id));
      }
    } finally {
      this.isFilterLoading = false;
    }
  }

  get isDepartmentFilterSettable(): boolean {
    return this.isDepartmentFilterEnable && !!this.departmentEntities;
  }

  get isProfessionFilterSettable(): boolean {
    return this.isProfessionsFilterEnable && !!this.professionEntities;
  }

  private toPreprocessOption(template: string): PreprocessOption {
    try {
      const replaced = template
        .replace(new RegExp("\\s*preprocess\\s*\\?\\s*\\{"), "")
        .replace(new RegExp("\\s*\\}"), "");
      const parsed = JSON.parse(replaced);
      if (!parsed) { return null; }
      return {
        departmentCodes: parsed.departmentCodes,
        authorRoleCodes:  parsed.authorRoleCodes,
      };
    } catch {
      return null;
    }
  }

  private async getDepartments(): Promise<Department[]> {
    try {
      const repository = DomainRegistry.department.getDepartmentRepository();
      return await repository.getAllEntities();
    } catch (e) {
      this.$error(
        this.$wording.common.department + "情報取得失敗",
        this.$wording.common.department + "情報を取得できませんでした。",
        e
      );
    }
  }

  private async getProfessions(): Promise<Profession[]> {
    try {
      const repository = DomainRegistry.user.getProfessionRepository();
      return await repository.getAllEntities();
    } catch (e) {
      this.$error(
        "職種情報取得失敗",
        "職種情報を取得できませんでした。",
        e
      );
    }
  }

  private async setFilterMaster(): Promise<void> {
    if (this.isDepartmentFilterEnable) {
      this.departmentEntities = await this.getDepartments();
    }
    if (this.isProfessionsFilterEnable) {
      this.professionEntities = await this.getProfessions();
    }
  }

  toDurationString(duration: DateDuration): string {
    return Moment(duration.from).format("YYYY/MM/DD") + "-" + Moment(duration.to).format("YYYY/MM/DD");
  }

  confirm(action: Action): void {
    this.action = action;
    this.isVisible = false;
  }

  close(): void {
    this.isVisible = false;
  }
}
